// extracted by mini-css-extract-plugin
export default {"attachments":"LWyiSxwuoehlY1hpDwLk","attachment":"ZFzhm6s92XV0TZHi73qj","attachmentItem":"WCVi9Iewiteyoiuh81wz","removeAttachmentButton":"NEBdpE6pForVhM6qZAFo"};